import { Inject, Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Request } from 'express';
import { REQUEST } from '../../../express.tokens';

const isServer = typeof window === 'undefined';

@Injectable({
  providedIn: 'root'
})
export class GatewayInterceptor implements HttpInterceptor {

  constructor(@Optional() @Inject(REQUEST) private request: Request | null) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isServer) {
      return next.handle(req);
    }

    // SSR calls backend over the ECS task's internal network, so the Host
    // header reaching pdp-api is the task IP (e.g. 161.0.2.101) — backend
    // can't find a tenant for that. Propagate the original user-facing host
    // as x-host (read by RequestUtils.getDomainName before falling back to
    // Host) so tenant resolution sees the customer domain. x-source labels
    // the caller so pdp-api logs can distinguish shop SSR from end-user
    // browser traffic.
    const headers: Record<string, string> = { 'x-source': 'shop-ssr' };
    const hostname = this.request?.hostname;
    if (hostname) {
      headers['x-host'] = hostname;
    }
    const forwarded = req.clone({ setHeaders: headers });

    const start = process.hrtime.bigint();
    console.log(`[SSR HTTP ENTER] ${forwarded.method} ${forwarded.url}`);

    return next.handle(forwarded).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const durationMs = Number(process.hrtime.bigint() - start) / 1e6;
            console.log(
              `[SSR HTTP] ${forwarded.method} ${forwarded.url} - ${durationMs.toFixed(0)}ms`,
            );
          }
        },
        error: (err) => {
          const durationMs = Number(process.hrtime.bigint() - start) / 1e6;
          console.log(
            `[SSR HTTP ERR] ${forwarded.method} ${forwarded.url} - ${durationMs.toFixed(0)}ms - ${err?.status || 'unknown'}`,
          );
        },
      }),
    );
  }
}